'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { FontWeight } from '../../util/font.js';
import { Tooltip } from '../tooltip/tooltip.js';
import { getButtonStyles, ButtonSizeToIconStyles, ButtonSize, ButtonColor, ButtonWidth } from './constants.js';

/**
 * Primary UI component for user interaction
 */
const Button = forwardRef(({ buttonColor = ButtonColor.WHITE, disabled, fontWeight = FontWeight.MEDIUM, label, LeftIcon, RightIcon, CustomLeftIcon, CustomRightIcon, rounded, selected, hideLabel, size = ButtonSize.MEDIUM, tooltipContent, width = ButtonWidth.AUTO, ...props }, ref) => {
    const button = (jsxs("button", { type: "button", ...props, className: `${getButtonStyles({
            buttonColor,
            size,
            width,
            fontWeight,
            rounded,
            selected,
        })} ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} focus:outline-none`, "aria-label": label, disabled: disabled, ref: ref, children: [CustomLeftIcon ? (jsx(CustomLeftIcon, { iconClassName: ButtonSizeToIconStyles[size] })) : LeftIcon ? (jsx(LeftIcon, { className: ButtonSizeToIconStyles[size] })) : null, hideLabel ? null : jsx("span", { children: label }), CustomRightIcon ? (jsx(CustomRightIcon, { iconClassName: ButtonSizeToIconStyles[size] })) : RightIcon ? (jsx(RightIcon, { className: ButtonSizeToIconStyles[size] })) : null] }));
    return tooltipContent ? (jsx(Tooltip, { asChild: true, content: tooltipContent, children: button })) : (button);
});
Button.displayName = 'Button';

export { Button, ButtonColor, ButtonSize, ButtonWidth };
//# sourceMappingURL=button.js.map
